module.exports = __webpack_public_path__ + "img/a2fc325.jpg";